import BaseProxyController from '~/service/base'
import type { CatalogProductsAPIQueryParams, QueryProductsAPIResponse } from '~/types/shop'
import { addCommonQueryParam } from '~/utils/general'

abstract class ShopServiceBase {
  BASE_URL = 'products'
  private readonly api = $api()
  private readonly isDemo = useSAuthState().isDemo

  fetchProductList (params: CatalogProductsAPIQueryParams, withPages: boolean, viewAsDate: string | undefined | null = undefined) {
    const query: Record<string, string | string[]> = {}

    Object.entries(params).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        query[key] = value.map(val => val)
      } else if (value || (key === 'pageSize' && value === 0)) {
        // pageSize 0 is a value, not an absence: the static-filter query asks for it
        // to get the filter facets without products. Dropping it (as nuxt2 did) got a
        // full default page back - 77 KB instead of 18 KB on production. Only pageSize:
        // any other 0 (a CMS carousel passes its query string through as numbers) is
        // still dropped, as before.
        query[key] = value
      }
    })

    if (!query.searchType) {
      query.searchType = 'all'
    }

    if (viewAsDate && !query.viewAsDate) {
      query.viewAsDate = viewAsDate
    }
    return this.api<QueryProductsAPIResponse>(withPages ? (this.isDemo.value ? 'search/combineSearch' : 'search') : this.BASE_URL, { query })
  }

  async fetchSabList () {
    const query = addCommonQueryParam()
    return (await this.api<QueryProductsAPIResponse>(
      `${this.BASE_URL}/promo`,
      {
        query
      }
    ))
  }
}

class ShopService extends ShopServiceBase {
}

export default () => {
  const checkoutProxyController = new BaseProxyController({
    UserService: ShopService
  })
  const proxy = new Proxy<ShopService>({} as unknown as ShopService, checkoutProxyController)
  return proxy
}
